import { useDispatch, useSelector } from "react-redux";
import HeaderHome from "../components/headerHome";
import { closeMessage } from "../slices/messageSlice";
import { Alert, Snackbar, Slide } from "@mui/material";
import { useState, useEffect } from "react";

// Tạo hàm SlideTransition cho Snackbar
function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

export default function HomeLayout({ children }) {
  const message = useSelector((state) => state.message);
  const dispatch = useDispatch();

  // Quản lý trạng thái của Snackbar để thêm Transition
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    Transition: SlideTransition,
  });

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarState({ ...snackbarState, open: false });
    dispatch(closeMessage());
  };

  // Khi có message mới, mở Snackbar với SlideTransition
  useEffect(() => {
    if (message?.isOpen) {
      setSnackbarState({
        open: true,
        Transition: SlideTransition, // Luôn sử dụng SlideTransition
      });
    }
  }, [message]);

  return (
    <div className="h-screen w-screen relative md:overflow-x-hidden">
      <HeaderHome />
      <div className=" w-screen pt-20">{children}</div>
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        TransitionComponent={snackbarState.Transition}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        sx={{ bottom: 50, right: 50 }}
      >
        <Alert onClose={handleSnackbarClose} severity={message?.severity}>
          {message?.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
